import MediaQuery from 'react-responsive'
import renameUnsafeLifecycleMethods from 'd2/hocs/RenameUnsafeLifecycleMethods'

// TODO: Remove 'as' type assertions because they are unsafe.
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export default renameUnsafeLifecycleMethods(MediaQuery) as typeof MediaQuery
